export default __webpack_public_path__ + "static/media/DMI-600.4e11c53a.pdf";